import React, { useState, useEffect } from 'react'
import { animated as a, useSpring } from 'react-spring'

// Component
const Footer = ({ isVisible }) => {
  // Load/View detection
  const [loaded, setLoaded] = useState(false)

  const load = isVisible => {
    if (isVisible && !loaded) {
      setLoaded(true)
    }
  }

  useEffect(() => {
    load(isVisible)
  }, [isVisible])

  // Animation of letterSpacing
  const { ls } = useSpring({
    ls: loaded ? 0.5 : 2,
    config: { duration: 1000 },
  })

  return (
    <div className="footer">
      <a.div
        className="footer-inner"
        style={{ letterSpacing: ls.interpolate(ls => `${ls}em`) }}
      >
        Pragun Saini
      </a.div>
    </div>
  )
}

export default Footer
